import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Warning = styled.div`
  padding: 15px;
  border: ${({ theme }) => `1px solid ${theme.palette.system.red}`};
  background-color: #ffe6e6;
`;

export const WarningTitle = styled(Typography.Header).attrs(() => ({
  $variant: '3',
}))`
  color: #fc433f;
  margin-bottom: 5px;
`;

export const WarningDescription = styled(Typography.Caption).attrs(() => ({
  $variant: '2',
}))`
  color: ${({ theme }) => theme.palette.primary.labels};

  a {
    color: ${({ theme }) => theme.palette.system.deepBlue};
  }
`;
